import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    iconButton: {
        color: theme.palette.colors.darkBlack[100]
    },
    ...theme.palette.components.moreOptions
}));